export const ACCEPT_COOKIES = {
  name: 'c_accept',
  expires: 365 * 5,
};

export const FACEBOOK_COOKIE = {
  name: 'fid',
  expirationDate: () => new Date(Date.now() + 30 * 60 * 1000), // 30 mins
  hashLength: 24,
};

export const USER_COOKIE = {
  name: 'sesid',
  expires: 365, // 1 year

  /** @deprecated this is just here for backward compatibility. Should not be used anymore */
  oldName: 'user_id_hash',
};

export const ORIGINAL_URL_COOKIE = {
  name: 'sesurl',
  // 30 min
  expirationDate: () => new Date(Date.now() + 30 * 60 * 1000),

  /** @deprecated this is just here for backward compatibility. Should not be used anymore */
  oldName: 'cosurl',
};

export const SUPPORT_COUNTRY_FILTER_COOKIE = {
  // scf stands for "support country filter"
  name: 'scf_active',
  expires: 365,
};

export const AB_TEST_COOKIE_NAME = 'ab_test';

export const ORIGINAL_LOCATION_COOKIE_NAME = 'mde_original_location';
